/**
 * Minimal no-op implementation for SSR environments.
 * Provides the IDBOpenDBRequest interface without relying on EventTarget.
 * This class does not extend EventTarget, making it safe to instantiate in Node.js.
 */
export class IDBOpenDBRequestNoOp implements IDBOpenDBRequest {
	private _error: DOMException | null = null;
	private _result: IDBDatabase | null = null;
	private _readyState: IDBRequestReadyState = 'pending';
	private _source: IDBObjectStore | IDBIndex | IDBCursor = null as any;
	private _transaction: IDBTransaction | null = null;

	get error(): DOMException | null {
		return this._error;
	}

	get result(): any {
		return this._result;
	}

	get readyState(): IDBRequestReadyState {
		return this._readyState;
	}

	get source(): IDBObjectStore | IDBIndex | IDBCursor {
		return this._source;
	}

	get transaction(): IDBTransaction | null {
		return this._transaction;
	}

	onerror: ((this: IDBRequest<any>, ev: Event) => any) | null = null;
	onsuccess: ((this: IDBRequest<any>, ev: Event) => any) | null = null;
	onblocked: ((this: IDBOpenDBRequest, ev: Event) => any) | null = null;
	onupgradeneeded: ((this: IDBOpenDBRequest, ev: IDBVersionChangeEvent) => any) | null = null;

	// No-op event methods for SSR
	addEventListener(): void {}
	removeEventListener(): void {}
	dispatchEvent(): boolean {
		return false;
	}

	// Wrapper-specific methods that shouldn't be called in SSR but are part of the interface
	wrapRequest(): void {
		throw new Error('IDBOpenDBRequestWrapper cannot wrap requests in SSR environment');
	}

	isWrapping(): boolean {
		return false;
	}

	getWrappedRequest(): IDBOpenDBRequest | null {
		return null;
	}

	unbind(): void {}

	setError(error: DOMException | null): void {
		this._error = error;
	}

	setResult(result: IDBDatabase | null): void {
		this._result = result;
	}

	setReadyState(state: IDBRequestReadyState): void {
		this._readyState = state;
	}

	setSource(source: IDBObjectStore | IDBIndex | IDBCursor): void {
		this._source = source;
	}

	setTransaction(transaction: IDBTransaction | null): void {
		this._transaction = transaction;
	}
}
